import {ApiManager} from './api';

export const Ask = (question,session_id) => {
    const data = {
        "question": question,
        "session_id": session_id
    }
    return ApiManager.post('/chat-bot', data)
}

export const getSession = () => {
    return ApiManager.get('/chat-bot')
}